import { render, staticRenderFns } from "./AssessmentsTable.vue?vue&type=template&id=4172d196&"
import script from "./AssessmentsTable.vue?vue&type=script&lang=js&"
export * from "./AssessmentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports